import {observer} from 'mobx-react-lite'
import React, {useCallback} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {AggregatedDeadline} from '@components/aggregated/aggregated-deadline'
import {AggregatedNumericStickers} from '@components/aggregated/aggregated-numeric-stickers'
import {AggregatedUsers} from '@components/aggregated/aggregated-users'
import {IconButtonNew} from '@components/common/base/buttons'
import {ProgressBar} from '@components/common/base/progress-bar/progress-bar'
import {useStore} from '@components/subtasks-old/subtasks-store'
import {cn} from '@containers/html-utils'

const TwChecklistToggleButton = tw(IconButtonNew)`
  flex-none
  text-secondary
  group-hover/task-subtasks-aggregated:text-action-default
  group-active/task-subtasks-aggregated:text-action-pressed
`

const TwSubtasksAggregatedInfo = tw.div<{$open: boolean}>`
  flex
  flex-col
  gap-8
  min-w-0
  group
  group/task-subtasks-aggregated
  pt-4
  ${p =>
    cn(
      p.$open &&
        cn('-ml-8', 'pl-24', 'pb-8', 'bg-[url(/img/line.svg)]', 'bg-repeat-y')
    )}
`

const TwRow = tw.div`
  flex
  items-center
  gap-8
  empty:hidden
`

const TwProgressBar = tw(ProgressBar)<{$allCompleted: boolean}>`
  flex-1
  ${p => cn(p.$allCompleted && '!text-placeholder-new')}
`

export const SubtasksAggregatedInfo = observer(() => {
  const [state, store] = useStore()

  const onClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      store.toggleOpen()
    },
    [store]
  )

  const bgColor = state.open ? 'background-disabled' : 'line-base'
  const outline = state.open ? 'background-subtask-open' : 'background-disabled'
  const icon = state.open ? 'IconChevronUp' : 'IconChevronDown'

  return (
    <TwSubtasksAggregatedInfo $open={state.open} onClick={onClick}>
      <TwRow>
        <TwProgressBar
          $allCompleted={store.allCompleted}
          value={store.doneCount}
          maxValue={store.subtasks.length}
          bgColor={bgColor}
        />
        <TwChecklistToggleButton icon={icon} />
      </TwRow>
      <TwRow className="flex-wrap">
        <AggregatedUsers
          users={store.allUsers}
          title={Lang.msg.subtask.assignedUsers}
          outlineColor={outline}
        />
        <AggregatedDeadline items={store.deadlines} colored />
        <AggregatedNumericStickers />
      </TwRow>
    </TwSubtasksAggregatedInfo>
  )
})
